/**
 * Admin / ops Zod schemas (m10).
 */

import { z } from 'zod';
import { IndianPhoneSchema, UidSchema } from './common';

export const NodalOfficerInputSchema = z.object({
  userId: UidSchema.nullable().optional(),
  phone: z.union([IndianPhoneSchema, z.string().max(30)]).nullable().optional(),
  email: z.string().email().nullable().optional(),
  publishedAt: z.string().datetime().nullable().optional(),
});

export const BulkUidsInputSchema = z.object({
  uids: z.array(UidSchema).min(1).max(500),
});

export type NodalOfficerInput = z.infer<typeof NodalOfficerInputSchema>;
export type BulkUidsInput = z.infer<typeof BulkUidsInputSchema>;
